import { ConstValues } from '@cloud-wave/neon-common-lib';

const PanelTypes = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  DANGER: 'DANGER',
  INFO: 'INFO',
  LOADING: 'LOADING',
} as const;

type TPanelTypes = ConstValues<typeof PanelTypes>;
export type { TPanelTypes };
export default PanelTypes;
